const DEFAULT_RESOLUTION = 5 * 60 * 1000;

type TimeRangeBucketsType = {
  startTime: Date;
  endTime: Date;
  resolution?: number;
};

export const timeRangeBuckets = ({ startTime, endTime, resolution = DEFAULT_RESOLUTION }: TimeRangeBucketsType) => {
  const buckets = [];

  for (let timestamp = startTime.getTime(); timestamp < endTime.getTime(); timestamp += resolution) {
    const intervalStart = new Date(timestamp);
    const nextTimestamp = timestamp + resolution;
    const isLastItem = nextTimestamp >= endTime.getTime();
    const intervalEnd = isLastItem ? endTime : new Date(nextTimestamp);

    buckets.push({
      startAt: intervalStart,
      endAt: intervalEnd,
      isLast: isLastItem,
    });
  }

  return buckets;
};
